export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO'; 
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';
export const LIMPIAR_ERROR = 'LIMPIAR_ERROR';
export const MENSAJE_LICENCIA = 'MENSAJE_LICENCIA';
export const SET_GLOBALSETTINGS = 'SET_GLOBALSETTINGS';
export const UPDATE_COLUMNS_PREFERENCES_USUARIO = 'UPDATE_COLUMNS_PREFERENCES_USUARIO';
export const NOT_SHOW_TERMS = 'NOT_SHOW_TERMS';